const competenciesTypes = {

  get: {
    request: "GET_COMPETENCY_REQUEST",
    success: "GET_COMPETENCY_SUCCESS",
    failure: "GET_COMPETENCY_FAILURE"
  },

  index: {
    request: "COMPETENCIES_INDEX_REQUEST",
    success: "COMPETENCIES_INDEX_SUCCESS",
    failure: "COMPETENCIES_INDEX_FAILURE"
  },

  create: {
    init:    "CREATE_COMPETENCY_INIT",
    request: "CREATE_COMPETENCY_REQUEST",
    success: "CREATE_COMPETENCY_SUCCESS",
    failure: "CREATE_COMPETENCY_FAILURE"
  },

  update: {
    request: "UPDATE_COMPETENCY_REQUEST",
    success: "UPDATE_COMPETENCY_SUCCESS",
    failure: "UPDATE_COMPETENCY_FAILURE"
  },

  destroy: {
    request: "DESTROY_COMPETENCY_REQUEST",
    success: "DESTROY_COMPETENCY_SUCCESS",
    failure: "DESTROY_COMPETENCY_FAILURE"
  },

  set_errors: "SET_COMPETENCY_ERRORS",

  reset: "RESET_COMPETENCY"

}

export default competenciesTypes



// WEBPACK FOOTER //
// ./src/js/constants/competenciesTypes.js